import React from 'react'
import { JsonLd, JsonLdProps } from './JsonLd'
import { ViewAction } from './types'

export interface ViewActionJsonLdProps extends JsonLdProps, ViewAction {}

export const ViewActionJsonLd: React.FC<ViewActionJsonLdProps> = ({ type = 'ViewAction', keyOverride, ...rest }) => (
  <JsonLd type={type} keyOverride={keyOverride} {...rest} scriptKey="ViewAction" />
)
